/// Note: this is only used on some views, not all cases of pagination.
/// It is mainly relevant on views that are sometimes slow and where
/// we want to scroll-to-top when the load completes.

import { Spinner } from "~/jose_modern/spinner";
import { once } from "~/jose_modern/once";
import { onViewLoad } from "~/jose_modern/on_view_load";

let paginationClicked = false;
let handlersInitialized = false;

export function handlePossiblePaginationClick(element) {
  if (!element || !element.closest(".pagination")) return;

  paginationClicked = true;
  const container = document.querySelector("[data-ajax-table]");
  if (container) {
    Spinner.start(container);
  }
}

export function handlePaginationScrolling() {
  if (!paginationClicked) return;

  const container = document.querySelector("[data-ajax-table]");
  if (!container) return;

  paginationClicked = false;
  Spinner.stop(container);
  window.scrollTo(0, 0);
}

export function initializePaginationHandler() {
  const containers = document.querySelectorAll("[data-ajax-table]");
  if (containers.length === 0) return;

  if (!handlersInitialized) {
    handlersInitialized = true;

    document.addEventListener(
      "click",
      (event) => {
        const link = event.target.closest("a[data-remote]");
        handlePossiblePaginationClick(link);
      },
      true // Use capture phase
    );

    document.addEventListener("partial:replace", () => {
      handlePaginationScrolling();
    });
  }
}

// NOTE: users#edit_inventory and users#edit_finished_goods are NOT included here
// because inventory_adjustments.js handles pagination clicks directly on those views.
// It imports and calls handlePossiblePaginationClick() and handlePaginationScrolling()
// to avoid event interception issues.
onViewLoad(
  [
    "inventory_updates#index_for_user",
    "finished_good_updates#index_for_user",
    "users#inventory_snapshot",
    "users#finished_good_snapshot",
  ],
  () => {
    initializePaginationHandler();

    once(document, "pagination-partial-reinit", () => {
      document.addEventListener("partial:replace", () => {
        initializePaginationHandler();
      });
    });
  }
);
